export const jobs = [
  {
    id: 5,
    companyName: 'BJSS/CGI',
    startDate: 'May 2023',
    endDate: 'Present',
    position: 'Senior Software Engineer',
    responsibilities: [
      {
        id: 1,
        description:
          'Worked with British Airways to launch a site wide transformation with a particular focus from myself on a new homepage alongside personally leading the development for integrating with their new CMS',
        technology: ['TypeScript', 'React', 'Next.js'],
      },
      {
        id: 2,
        description: 'Developed solutions for IAG to integrate AI solutions into their staff scheduling system',
        technology: ['TypeScript', 'React', 'Next.js', 'Python', 'AWS'],
      },
      {
        id: 3,
        description:
          'Helped develop a new platform for the Veterinary Medical Association to manage the licensing and import of veterinary medication.',
      },
      {
        id: 4,
        description:
          'Developed the frontend on an internal project that utilised AI to help our bid team create proposals more efficiently',
        technology: ['TypeScript', 'React', 'Next.js', 'AWS', 'C#'],
      },
      {
        id: 5,
        description:
          'Worked with the Scottish Qualifications Authority building their new website following a rebrand and redesign plus integrating with their new CMS',
        technology: ['TypeScript', 'React', 'Next.js', 'Azure', 'contentful'],
      },
    ],
  },
  {
    id: 4,
    companyName: 'Aviva',
    startDate: 'November 2022',
    endDate: 'May 2023',
    position: 'Software Engineer',
    responsibilities: [
      {
        id: 1,
        description: 'Contributed as part of the support team to fix bugs impacting customers',
        technology: ['TypeScript', 'React', 'Next.js', 'Go', 'AWS'],
      },
    ],
  },
  {
    id: 3,
    companyName: 'Made Tech',
    startDate: 'February 2021',
    endDate: 'July 2022',
    position: 'Senior software engineer',
    responsibilities: [
      {
        id: 3,
        description: 'Built a prototype of the Met Office weather app as part of a bid that won the contract',
        technology: ['JavaScript', 'TypeScript', 'React', 'next.js', 'vercel'],
      },
      {
        id: 2,
        description:
          'Worked on Homes for Ukraine with DLUHC to build forms that allowed UK residents to express their interest in offering any spare bedrooms to Ukrainian refugees',
        technology: ['Ruby', 'Ruby on Rails'],
      },
      {
        id: 1,
        description:
          'Worked with Hackney social care to build a web application for social care workers to facilitate their work within the community',
        technology: ['JavaScript', 'TypeScript', 'React', 'next.js', 'C#', '.NET', 'AWS'],
      },
    ],
  },
  {
    id: 2,
    companyName: 'CACI IIG',
    startDate: 'April 2019',
    endDate: 'January 2021',
    position: 'Junior/Senior software engineer',
    responsibilities: [
      {
        id: 1,
        description:
          'Developed a project management application that integrated with Jira’s ' +
          'API to allow for ticket management between multiple teams',
        technology: ['JavaScript', 'TypeScript', 'React'],
      },
      {
        id: 2,
        description:
          'Designed and developed the frontend of a web application that tested the performance of regular expressions',
        technology: ['JavaScript', 'TypeScript', 'React', 'Adobe XD'],
      },
      {
        id: 3,
        description: 'Developed an application that allowed the configuration of communication devices',
        technology: ['JavaScript', 'TypeScript', 'React', 'Java', 'Spring', 'SNMP'],
      },
      {
        id: 4,
        description:
          'Developed a web app that gave government contractors a collaborative online platform to create work proposals',
        technology: ['JavaScript', 'TypeScript', 'Angular', 'Java', 'Spring', 'SQL'],
      },
      {
        id: 5,
        description: 'Developed an internal web app so that all new-joiners could take a required security quiz',
        technology: ['JavaScript', 'TypeScript', 'Vue', 'Java', 'Spring'],
      },
    ],
  },
  {
    id: 1,
    companyName: 'TCS',
    startDate: 'December 2017',
    endDate: 'August 2018',
    position: 'Junior software engineer',
    responsibilities: [
      {
        id: 1,
        description: 'Worked on a large scale cloud industrialisation project',
        technology: ['C#, AWS'],
      },
    ],
  },
] as const;
